import { ShopItem } from '@/types/Types'
import Dexie, { Table } from 'dexie'

export class ItemListDexie extends Dexie {
  shopItems!: Table<ShopItem>

  constructor() {
    super('shopItemDatabase')
    this.version(1).stores({ shopItems: '++id, uuid, name, count, enabled' })
  }
}

export const itemListDB = new ItemListDexie()
